import { api } from "./api";
export const addApprovalWorkFlowApi = (params) => {
  return api.post("/approval-flows", JSON.stringify(params));
};
export const getAllUsersByRoleIdApi = (params) => {
  return api.get(`/user/getAllUserDropdown?role_id=${params.role_id}`);
};
export const addOriginatorsApi = (params) => {
  return api.post("/approval-flows/originators", JSON.stringify(params));
};
export const getMainModulesApi = (params) => {
  return api.get("/template/mainModules/getAll");
};
export const getSubModulesApi = (params) => {
  return api.get(`/template/subModules/getAll?main_module_id=${params.module_id}`);
};
export const getColumnsApi = (params) => {
  return api.get(`/getColumnList?transaction_type=${params.transaction_type}`);
};
export const addDocumentsApi = (params) => {
  return api.post("/approval-flows/documents", JSON.stringify(params));
};
export const addStagesApi = (params) => {
  return api.post(`/approval-flows/stages`, JSON.stringify(params));
};
export const getApprovalListApi = (params) => {
  return api.get(`/approval-flows/user/get/approvallist?pageNumber=${params.pageNumber}&pageSize=${params.pageSize}&selectedColumn=${params.selectColumn}&value=${params.inputValue}`);
};
export const getApprovalAcceptanceApi = (params) => {
  return api.get(`/approval-flows/user/get/approvalStages/getById?request_id=${params.request_id}`);
};
export const approverActionApi = (params) => {
  return api.post(`/approval-flows/user/update/stage`,JSON.stringify(params));
};